import React, { Component } from "react";
import { Button, Table, Form, FormGroup, Card, CardBody, Label, Input } from 'reactstrap';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { TRAHANG_DETAIL_SUCCESS } from './constants'
import orderConstants, * as constants from "../Order/constants"
import * as traHangAction from './actions'
import { storedb } from '../../views/client/storedb'
import * as common from '../../lib/common'
import NumberFormat from 'react-number-format';
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class TraHang extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {},
      formError: {},
      formValid: false,
      StoreId: dbContext.getStoreId(),
      OrderId: "",
      OrderType: 0,
      GhiChu: "",
      ThemCongNo: true,
      ListProduct: []
    };
  }
  checkParamsOrder = (callback) => {
    const params = this.props.match ? this.props.match.params : {};
    if (params) {
      const { type, id } = params;
      this.setState({ OrderId: id, OrderType: type }, function () {
        callback()
      });
    }
  }
  handleControlChange = (e) => {
    this.setState({ GhiChu: e.target.value })
  }
  fetchDetail = () => {
    const { traHangDetailRequest } = this.props
    let requestData = {
      StoreId: this.state.StoreId,
      order_id: this.state.OrderId,
      mode: orderConstants.MODE.IN_VIEW
    };
    return traHangDetailRequest(requestData);
  }
  search = () => {
    if (this.props.traHang.requesting) {
      return false;
    }
    return this.fetchDetail()
  }
  UpdateTraHang = () => {
    let arrProduct = [];
    let listProduct = this.state.ListProduct;
    const { traHangUpdateRequest } = this.props
    if (listProduct && listProduct.length > 0) {
      arrProduct = listProduct.map((res, idx) => {
        return { 
          item_id: res.product_id, 
          so_luong: res.so_luong, 
          so_luong_tra: res.so_luong_tra || 0,
          is_km: res.is_km,
        }
      })
    }
    
    let requestData = {
      order_id: this.state.OrderId,
      store_id: this.state.StoreId,
      ghi_chu: this.state.GhiChu,
      is_cong_no: this.state.ThemCongNo,
      items: arrProduct
    }
    const onSuccess = () => {
      setTimeout(this.fetchDetail, 1500)
    }
    
    return traHangUpdateRequest(requestData, onSuccess);
  }
  BackToListDonHang = () => {
    const {OrderType, OrderId} = this.state;
    this.props.history.push(`/order-view/${OrderType}/${OrderId}`);
  }
  handleSoluongTraChange(e, item) {
    const value = e.floatValue || 0;
    this.updateSoluongTra(item, value);
  }
  handleCongNo = () => {
    this.setState({
      ThemCongNo: !this.state.ThemCongNo
    })
  }
  updateSoluongTra = (item, soLuongTra) => {
    let { ListProduct } = this.state;
    const index = ListProduct.findIndex(x => x.product_id === item.product_id && x.is_km == item.is_km);
    if (index > -1) {
      const allowance = ListProduct[index].so_luong - (ListProduct[index].so_luong_da_tra || 0)
      if (soLuongTra > allowance) {
        soLuongTra = allowance
      }

      ListProduct[index].so_luong_tra = soLuongTra;
      this.setState({ ListProduct });
    }
  }
  componentDidMount() {
    this.checkParamsOrder(() => {
      this.fetchDetail();
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.traHang.type == TRAHANG_DETAIL_SUCCESS) {
      let { item } = nextProps.traHang
      this.setState({ item, ListProduct: item.items });
    }
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  render() {
    const { formError, item, ListProduct } = this.state
    const {
      handleSubmit,
      traHang: {
        requesting,
        errors,
        messages
      },
    } = this.props
    
    // co cho phep edit item hay khong
    const isReturnItemAllowed = (item) => {
      if (!item.so_luong_da_tra || item.so_luong_da_tra <= 0) return true
      if (item.so_luong > item.so_luong_da_tra) return true
      return false
    }
    // co cho phep tra hang hay khong
    const isReturnAllowed = (items) => {
      if (!items) return false
      const itemsAllowed = items.filter(item => {
        return isReturnItemAllowed(item)
      })

      return itemsAllowed.length > 0
    }
    const isReturnEnabled = isReturnAllowed(ListProduct)
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting}>
          <div className="mt-2 bg-white">
            <div className={`${isReturnEnabled ? "col-sm-9" : "col-sm-12"} pull-left`}>
              <Card>
                <CardBody className="p-1">
                  <div className="w-100">
                    <h5 className="text-success">THÔNG TIN ĐƠN HÀNG</h5>
                  </div>
                  <div className="col-sm-12">
                    <div className="col-sm-6 mb-2 pull-left view-row">
                      <span>Mã đơn hàng: <b>{item.ma_don_hang}</b></span>
                    </div>
                    <div className="col-sm-6 mb-2  pull-left view-row">
                      <span>Trạng thái: {common.getOrdetStatusText(item.trang_thai, true)}</span>
                    </div>
                    <div className="col-sm-6 mb-2  pull-left view-row">
                      <span>Khách hàng: <b>{item.ten_khach_hang}</b></span>
                    </div>
                    <div className="col-sm-6 mb-2  pull-left view-row">
                      <span>Địa chỉ: <b>{item.dia_chi}</b></span>
                    </div>
                    <div className="col-sm-6 mb-2  pull-left view-row">
                      <span>Điện thoại: <b>{item.dien_thoai}</b></span>
                    </div>
                    <div className="col-sm-6  pull-left view-row mb-2">
                      <span>Kí H/Đồng: <b>{item.hd_tham_gia}</b></span>
                    </div>
                    <div className="col-sm-6  pull-left view-row mb-2">
                      <span>Mã số thuế: <b>{item.ma_so_thue}</b></span>
                    </div>
                    <div className="col-sm-6 mb-2  pull-left view-row">
                      <span>Ngày lập: <b>{common.formatDateTime(item.ngay_lap, "DD-MM-YYYY")}</b></span>
                    </div>
                    <div className="col-sm-6 mb-2  pull-left view-row">
                      <span>Ngày giao: <b>{item.ngay_giao ? common.formatDateTime(item.ngay_giao, "DD-MM-YYYY") : ""}</b></span>
                    </div>
                    <div className="col-sm-6  pull-left view-row mb-2">
                      <span>Kho xuất: <b>{item.noi_xuat}</b></span>
                    </div>
                    <div className="col-sm-6  pull-left view-row mb-2">
                      <span>Xuất hóa đơn: <b>{item.xuat_hoa_don ? 'Có' : 'Không'}</b></span>
                    </div>
                    <div className="col-sm-6  pull-left view-row mb-2">
                      <span>Chiết khấu: <b>{item.bo_chiet_khau ? 'Bỏ chiết khấu' : "Có"}</b></span>
                    </div>
                    <div className="col-sm-12 mb-2 pull-left view-row">
                      <span>Ghi chú: <b>{item.ghi_chu}</b></span>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                  <div className="w-100  mb-2">
                    <h5 className="text-success">CHI TIẾT ĐƠN HÀNG</h5>
                    <div className="clearfix"></div>
                  </div>
                  <div className="w-100 mb-2">
                    <Table hover responsive className="table-outline mb-0 d-sm-table table-sm">
                      <thead className="thead-default">
                        <tr>
                          <th scope="col" className="text-center">#</th>
                          <th scope="col" className="text-left">Tên hàng</th>
                          <th scope="col" className="text-center">ĐVT</th>
                          <th scope="col" className="text-right">Số lượng</th>
                          <th scope="col" className="text-right">Đã trả</th>
                          <th scope="col" className={`text-right ${isReturnEnabled ? "" : "d-none"}`}>Trả lại</th>
                          <th scope="col" className="text-right">Đơn giá</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ListProduct && !!ListProduct.length && (
                          ListProduct.map((res, idx) => (
                            <tr key={idx + 1}>
                              <td className="text-center">{idx + 1}</td>
                              <td className="text-left">{res.ten_hang}</td>
                              <td className="text-center">{res.dvt}</td>
                              <td className="text-right">{(res.so_luong || 0).toLocaleString()}</td>
                              <td className="text-right">{(res.so_luong_da_tra || 0).toLocaleString()}</td>
                              <td className={`text-right ${isReturnEnabled ? "" : "d-none"}`}>
                                {isReturnItemAllowed(res) && (
                                  <NumberFormat
                                    name={"SoluongNhap" + idx}
                                    value={res.so_luong_tra || 0}
                                    defaultValue={1}
                                    thousandSeparator={"."}
                                    decimalSeparator={","}
                                    type="tel"
                                    autoComplete="off"
                                    onClick={e => this.numberOnclick(e)}
                                    onValueChange={e => this.handleSoluongTraChange(e, res)}
                                    className={"order-input-sl price number"} 
                                  />
                                )}
                              </td>
                              <td className="text-right">{(res.gia_ban || 0).toLocaleString()}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                    <div className="clearfix"></div>
                  </div>
                  <div className={`w-100 mb-2 ${isReturnEnabled ? "d-none" : ""}`}>
                    <Button size="md" color="secondary" className="mr-1 pull-right" onClick={e => this.BackToListDonHang(e)}><i className="fa fa-mail-reply"></i> Quay lại</Button>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className={`col-sm-3 pull-left pl-0 pr-0 ${isReturnEnabled ? "" : "d-none"}`}>
              <Card>
                <CardBody className="p-2">
                  <div className="w-100 mb-2">
                    <Form>
                      <FormGroup check className="mb-3">
                        <Label className="text-danger" check>
                          <Input type="checkbox" checked={this.state.ThemCongNo} onChange={this.handleCongNo} />{' '}
                          Thêm vào công nợ
                      </Label>
                      </FormGroup>
                      <FormGroup>
                        <textarea className="form-control" placeholder="Ghi chú" onChange={this.handleControlChange.bind(this)}></textarea>
                      </FormGroup>
                    </Form>
                  </div>
                  <div className="w-100 mb-2">
                    <Button size="md" color="secondary" className="mr-1" onClick={e => this.BackToListDonHang(e)}><i className="fa fa-mail-reply"></i> Quay lại</Button>
                    <Button size="md" disabled={requesting} color="success" className="mr-1" onClick={handleSubmit(this.UpdateTraHang)}><i className="fa fa-retweet"></i> Trả hàng</Button>
                    <div className="error invalid-feedback">{formError.errMsg}</div>
                  </div>
                  <div>
                    {!requesting && !!errors.length && (
                      <Errors errors={errors} />
                    )}
                    {!requesting && !!messages.length && (
                      <Messages messages={messages} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  traHang: state.traHang,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  traHangDetailRequest: traHangAction.traHangDetailRequest,
  traHangUpdateRequest: traHangAction.traHangUpdateRequest,
})(TraHang)
const formed = reduxForm({
  form: 'traHang',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/TraHang/TraHang.js